module.exports = __webpack_public_path__ + "static/compass-button-9184e930926d31b200df76ed851ca145.png";